import React from "react";
import { cls } from "@wss/cls";

const OutletFooter = () => {
  return (
    <>
      <div className={cls("box", "padded", "clears", "mt-5")}>
        <h2 className="header-3">
          Scratch and Dent Appliances Can Help Your Restaurant, Bar, or Other
          Commercial Operation Save Money on High-Quality Equipment
        </h2>
        <p className={cls("small")}>
          If you&apos;re looking to save on new commercial equipment or you want
          to find discount kitchenware, our selection of scratch and dent
          appliances are the perfect option. We offer a large variety of new
          restaurant equipment that was damaged slightly during transit and is
          now being sold at a discount, so you can save money and still get new
          appliances. Best of all, you can find many different types of scratch
          and dent appliances, such as refrigerators, ovens, ranges, beverage
          equipment, commercial sinks, and much more.
        </p>
        <p className={cls("small")}>
          Our scratch and dent outlet has appliances for every type of
          foodservice establishment, from restaurants and bars to food trucks
          and healthcare facilities. Best of all, we list any scratches, marks,
          or dings on the equipment, so you know exactly what you&apos;re
          getting when you place an order. Additionally, this selection of
          scratch and dent appliances changes regularly, so be sure to check
          back to find all the equipment you need. And to make sure that
          you&apos;re getting a good deal on this discount restaurant equipment,
          be sure to compare it to our regular{" "}
          <a
            className={cls("underline")}
            href="/restaurant-equipment.html"
            target="_blank"
          >
            restaurant equipment
          </a>
          .
        </p>
      </div>
    </>
  );
};
export default OutletFooter;
